import { ResultsState } from '.'
import NoInput from './NoInput'
import NoResults from './NoResults'
import Results from './Results'
import { Spinner } from '@gassan-ui'
import { cn } from '@lib/cn'
import { FC } from 'react'

type Props = {
  query: string
  results: ResultsState
}

const ResultsList: FC<Props> = ({ query, results }) => {
  let render
  const status = results.status
  const totalResults = results.brands.length + results.categories.length + results.products.length
  if (query === '') {
    render = <NoInput />
  } else if (status === 'searching') {
    render = (
      <div className="text-shade-800">
        <Spinner size={30} />
      </div>
    )
  } else if (status === 'idle') {
    if (totalResults === 0 && query === '') {
      render = <NoInput />
    } else if (totalResults === 0) {
      render = <NoResults />
    } else {
      render = <Results {...results} query={query} />
    }
  } else {
    render = null
  }
  return <div className={cn('mt-4', 'md:mt-10')}>{render}</div>
}

export default ResultsList
